import { Helmet } from "react-helmet-async";
import { useI18n } from "../lib/i18n";
import { seo, OG_IMAGE } from "../lib/translations/seo";

const LOCALES = { en: "en_US", ja: "ja_JP", pl: "pl_PL" };

export default function SEO({ page, noindex = false }) {
  const { lang } = useI18n();
  const dict = seo[lang] || seo.en;
  const s = dict[page] || seo.en[page];

  return (
    <Helmet>
      <title>{s.title}</title>
      <meta name="description" content={s.desc} />
      <meta name="keywords" content={dict.keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={s.title} />
      <meta property="og:description" content={s.desc} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="World Rhubarb Association" />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:locale" content={LOCALES[lang] || "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={s.title} />
      <meta name="twitter:description" content={s.desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
